import { getSessionStorage, setSessionStorage } from "../util/sessionStorage";
import { REMEMBER_USER, RESET_STATE, APP_SETTINGS_UPDATE } from "./actions";

export const INITIAL_STATE_USER = {};
export const INITIAL_STATE_APP = { justLoggedIn: true };

export const redivizUser = (state = null, action) => {
  const { type, payload } = action;

  switch (type) {
    case REMEMBER_USER: {
      const { user } = payload;
      return user;
    }
    case RESET_STATE: {
      return INITIAL_STATE_USER;
    }
    default:
      return state;
  }
};

export const appSettings = (state = null, action) => {
  const { type, payload } = action;

  switch (type) {
    case APP_SETTINGS_UPDATE: {
      const newState = { ...state, ...payload };
      setAppSettingsStorage(newState);
      return newState;
    }
    case RESET_STATE: {
      setAppSettingsStorage(INITIAL_STATE_APP);
      return INITIAL_STATE_APP;
    }
    default:
      return state;
  }
};

export const loadAppSettingsSessionStorage = () => {
  return getSessionStorage("app_settings") || INITIAL_STATE_APP;
};

export const setAppSettingsStorage = (appSettings = null) => {
  setSessionStorage("app_settings", appSettings);
};
